// extracted by mini-css-extract-plugin
export default {"stages":"styles_stages__Tjcol","progress":"styles_progress__+gwIh","controls":"styles_controls__Sgp1X"};